import { useEffect, useState } from 'react';

// Include identity, filters and refresh generation; results never cross request boundaries.
export default function useDashboardResource(fetcher, path, params, enabled, refresh = 0) {
    const encoded = JSON.stringify(params);
    const key = JSON.stringify([path, encoded, refresh]);
    const [state, setState] = useState(null);
    useEffect(() => {
        if (!enabled) return;
        const controller = new AbortController();
        setState({ key, loading: true, data: null, error: '' });
        fetcher(path, JSON.parse(encoded), controller.signal).then(data => {
            if (!controller.signal.aborted) setState({ key, loading: false, data, error: '' });
        }).catch(error => {
            if (!controller.signal.aborted) setState({ key, loading: false, data: null,
                error: error.response?.data?.message || 'Unable to load data. Please retry.' });
        });
        return () => controller.abort();
    }, [fetcher, path, encoded, key, enabled]);
    return enabled && state?.key === key ? state : { data: null, error: '', loading: !!enabled };
}
